import React, { FC } from 'react';

import { usePageNavs }                          from '../../../hooks';
import { SystemAdminsOnly }                     from '../util/access/RoleAccessControl';
import { GenericNav, GenericNavComponentProps } from './GenericNav';

const DecisionEngineNav: FC<Partial<GenericNavComponentProps>> = ( props ) => {
	
	let { generateDecisionEngineSectionNav } = usePageNavs();
	
	let navObjects = generateDecisionEngineSectionNav();
	
	return (
		
		<SystemAdminsOnly>
			<GenericNav withParent={ true } navObjects={ navObjects } { ...props }/>
		</SystemAdminsOnly>
	);
};

export { DecisionEngineNav }
